import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { H3, H4, H6, P, Image, Btn } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import {
  MyProfile,
  Bio,
  Password,
  Website,
  Save,
  EmailAddress,
  EditProfile,
  Name,
} from "../../../../Constant";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import { Button } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { fetchUserDetails } from "../../../../api/user.api";

const OnboardingProfile = () => {
  const [details, setDetails] = useState({});
  const { userDetails, setUserDetails } = useAPIUser();
  const [image, setImage] = useState();
  const [avatar, setAvatar] = useState();

  const [nameError, setNameError] = useState(false);
  const [organisationNameError, setOrganisationNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [designationError, setDesignationError] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);

  useEffect(() => {
    getUserDetails();
  }, [userDetails]);

  const getUserDetails = () => {
    fetchUserDetails().then((res) => {
      setDetails(res);
    });
  };
  const editProfile = (e) => {
    setNameError(false);
    setOrganisationNameError(false);
    setEmailError(false);
    setDesignationError(false);
    setDepartmentError(false);

    const nameFieldTest = /^[A-Za-z]+[A-Za-z ]*$/;
    if (nameFieldTest.test(details.name)) {
      setNameError(false);
    } else {
      setNameError(true);
    }
    const organisationNameFieldTest = /^[A-Za-z]+[A-Za-z ]*$/;
    if (organisationNameFieldTest.test(details.organisation_name)) {
      setNameError(false);
    } else {
      setNameError(true);
    }

    const emailFieldTest = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailFieldTest.test(details.email)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }

    function departmentCheckFunction() {
      return true;
    }
    if (details.department) {
      const departmentFieldTest = /^[A-Za-z]+[A-Za-z ]*$/;
      departmentCheckFunction = () => {
        if (departmentFieldTest.test(details.department)) {
          setDepartmentError(false);
          return true;
        } else {
          setDepartmentError(true);
          return false;
        }
      };
    }

    function designationCheckFunction() {
      return true;
    }
    if (details.designation) {
      const designationTest = /^[A-Za-z]+[A-Za-z ]*$/;
      designationCheckFunction = () => {
        if (designationTest.test(details.designation)) {
          setDesignationError(false);
          return true;
        } else {
          setDesignationError(true);
          return false;
        }
      };
    }

    if (
      nameFieldTest.test(details.name) &&
      emailFieldTest.test(details.email) &&
      departmentCheckFunction() &&
      designationCheckFunction()
    ) {
      const values = new FormData();
      values.append("name", details.name);
      values.append("organisation_name", details.organisation_name);
      values.append("email", details.email);
      values.append("contact", details.contact);
      values.append("designation", details.designation);
      values.append("department", details.department);
      if (image) {
        values.append("signature", image);
      }
      if (avatar) {
        values.append("avatar", avatar);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`apiV1/user/${details.id}/`, values, config)
        .then((res) => {
          setDetails(res.data);
          setUserDetails(res.data);
          toast.success("Successfully edited details");
        })
        .catch((error) => {
          toast.error("Something went wrong. Please check all the fields");
        });
    } else {
      toast.error("Enter details correctly");
    }
  };
  return (
    <Fragment>
      <Card>
        <CardHeader className="pb-0">
          <H4 attrH4={{ className: "card-title mb-0" }}>Edit my profile</H4>
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Form>
            {/* <FormGroup className="mb-3">
                            <H6 attrH6={{ className: 'form-label' }}>{Bio}</H6>
                            <Input type="textarea" className="form-control" rows="5" defaultValue="On the other hand, we denounce with righteous indignation" />
                        </FormGroup> */}
            <FormGroup className="mb-3">
              <Label className="form-label">{Name}</Label>
              <Input
                className="form-control"
                placeholder="Name"
                defaultValue={details?.name}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    name: e.target.value,
                  });
                }}
              />
              {nameError ? (
                <span style={{ color: "red" }}>Enter a valid name</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">Organisation Name</Label>
              <Input
                className="form-control"
                placeholder="Organisation name"
                defaultValue={details?.organisation_name}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    organisation_name: e.target.value,
                  });
                }}
              />
              {organisationNameError ? (
                <span style={{ color: "red" }}>
                  Enter a valid organisation name
                </span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{EmailAddress}</Label>
              <Input
                className="form-control"
                placeholder="Email"
                defaultValue={details?.email}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    email: e.target.value,
                  });
                }}
              />
              {emailError ? (
                <span style={{ color: "red" }}>Enter a valid Email</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Designation"}</Label>
              <Input
                className="form-control"
                defaultValue={details?.designation}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    designation: e.target.value,
                  });
                }}
              />
              {designationError ? (
                <span style={{ color: "red" }}>Enter a valid Designation</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Department"}</Label>
              <Input
                className="form-control"
                defaultValue={details?.department}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    department: e.target.value,
                  });
                }}
              />
              {departmentError ? (
                <span style={{ color: "red" }}>Enter a valid Department</span>
              ) : null}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Signature"}</Label>
              <Input
                className="form-control"
                type="file"
                accept="image/jpg,image/png,image/jpeg"
                //defaultValue={details?.signature}
                onChange={(e) => {
                  setImage(e.target.files[0]);
                }}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label className="form-label">{"Add avatar"}</Label>
              <Input
                className="form-control"
                type="file"
                accept="image/jpg,image/png,image/jpeg"
                //defaultValue={details?.signature}
                onChange={(e) => {
                  setAvatar(e.target.files[0]);
                }}
              />
            </FormGroup>
            <div className="form-footer">
              <Button
                className="btn-block"
                onClick={(e) => {
                  editProfile(e);
                }}
              >
                {Save}
              </Button>
              {/* <Btn attrBtn={{ className: 'btn-block', color: 'primary',onclick:editProfile()}} >{Save}</Btn> */}
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default OnboardingProfile;
